import { render, staticRenderFns } from "./GroupTemplatesAssignmentForm.vue?vue&type=template&id=dba0f720&scoped=true"
import script from "./GroupTemplatesAssignmentForm.vue?vue&type=script&lang=js"
export * from "./GroupTemplatesAssignmentForm.vue?vue&type=script&lang=js"
import style0 from "./GroupTemplatesAssignmentForm.vue?vue&type=style&index=0&id=dba0f720&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba0f720",
  null
  
)

export default component.exports